import React from "react";
import { useTranslation } from "react-i18next";

const KitDigitalInfoSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="swiss-section">
      <div className="swiss-grid">
        <div className="col-span-12 lg:col-span-2 mb-6 lg:mb-0">
          <span className="swiss-num">— / {t("Programme")}</span>
        </div>
        <div className="col-span-12 lg:col-span-10">
          <h2 className="text-h2 font-bold tracking-tight text-ink mb-5 max-w-[22ch]">
            {t("Qué es el Kit Digital y Cómo Solicitarlo")}
          </h2>
          <p className="swiss-caption mb-7">
            {t("Descripción y Condiciones del Programa")}
          </p>
          <p className="text-body-lg text-ink-70 max-w-prose">
            {t(
              "El Programa Kit Digital ofrece subvenciones para apoyar la transformación digital de diversas entidades, incluidas pymes, autónomos, ONG, asociaciones, comunidades y sociedades civiles. Esta ayuda te permite crear o mejorar una página web, establecer una tienda online o mejorar tu presencia en internet. Además, incluye la gestión de redes sociales y otras herramientas digitales esenciales."
            )}
          </p>
        </div>
      </div>
    </section>
  );
};

export default KitDigitalInfoSection;
